import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AvThemeToggleComponent } from '../../Shared/Components/theme-toggle/theme-toggle.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [RouterOutlet, AvThemeToggleComponent, TranslatePipe],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent {
  readonly version = environment.version;
}
